import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArchiveRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16.5 4.5V6.5H3.5V4.5H16.5ZM2 6.5C2 7.15312 2.41875 7.70937 3 7.91563V15C3 16.1031 3.89688 17 5 17H15C16.1031 17 17 16.1031 17 15V7.91563C17.5813 7.70937 18 7.15312 18 6.5V4.5C18 3.67188 17.3281 3 16.5 3H3.5C2.67188 3 2 3.67188 2 4.5V6.5ZM4.5 15V8H15.5V15C15.5 15.275 15.275 15.5 15 15.5H5C4.725 15.5 4.5 15.275 4.5 15ZM7.75 9.5C7.33437 9.5 7 9.83437 7 10.25C7 10.6656 7.33437 11 7.75 11H12.25C12.6656 11 13 10.6656 13 10.25C13 9.83437 12.6656 9.5 12.25 9.5H7.75Z" })
});
export default SvgArchiveRegularIcon;
